import React from 'react';

function Parse({ htmlString }) {
  const parsedHtml = new DOMParser().parseFromString(htmlString, 'text/html');
  const reactElement = React.createElement('p', { dangerouslySetInnerHTML: { __html: parsedHtml.body.innerHTML } });
  return reactElement;
}
export default Parse;